export default global.confirm.bind(global.window)
